export const isProjectCompletedForCustomer = project => project.status_for_customer === 'complete';
export const isProjectInProgressForCustomer = project =>
  project.status_for_customer === 'in_progress';

export const isProjectCategoryReleasedForCustomer = project =>
  project.category_release_status === 'approved';
export const isConsultancy = project => project.plan === 'consultancy';



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/utils/projectStatusForCustomer.js